// extracted by mini-css-extract-plugin
export default {"card":"MZ-z","carouselContainer":"NZ-z","carouselContent":"OZ-z"};